import { Box, type SxProps, type Theme } from "@mui/material";

import { mergeSxProps } from "../../lib/mergeSxProps";
import { Text } from "../Text";

export interface KeyValueListItemProps {
  label: string;
  value: string | React.ReactNode;
  sx?: SxProps<Theme>;
}

export function KeyValueListItem(props: KeyValueListItemProps) {
  const { label, value, sx } = props;

  return (
    <Box
      sx={mergeSxProps(
        {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "transparent",
          py: 2,
        },
        sx
      )}
    >
      <Text variant="body1" color="text.secondary">
        {label}
      </Text>
      <Text bold variant="body1" color="text.primary">
        {value}
      </Text>
    </Box>
  );
}
